// ===================================================
// main
// ===================================================

window.addEventListener("load", function () {
  // *************** topPage loader ***************
  // const fileName = window.location.href.split("/").pop();
  const loader = document.querySelector("#loader");

  if (loader) {
    setTimeout(function () {
      loader.classList.add("is_hide");
    }, 1200);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // *************** article loader ***************
  const pageTransition = document.querySelector("#pageTransition");
  if (pageTransition) {
    pageTransition.classList.add("is_hide");
  }

  // *************** slider ***************
  class Slider {
    constructor(el, options) {
      this.el = el;
      this.options = {
        autoplay: options.autoplay,
        breakpoints: options.breakpoints,
      };
      this.swiper = this._initswiper();
    }

    _initswiper() {
      return new Swiper(this.el, {
        loop: true,
        speed: 1200,
        autoplay: this.options.autoplay,
        effect: "slide",
        centeredSlides: true,
        loopSlides: 1,
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        breakpoints: this.options.breakpoints,
      });
    }
  }

  const swiper = new Slider(".swiper-container", {
    // autoplay: 'false',
    autoplay: { delay: 3000 },
  });

  const swiper2 = new Slider(".swiper-container-02", {
    autoplay: { delay: 3000 },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      880: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

  // *************** drawer ***************
  class Drawer {
    constructor() {
      this.globalContainer = document.querySelector("#globalContainer");
      this.btn = document.querySelector(".el_drawerBtn");
      this.cover = document.querySelector(".ly_drawer_cover");
      this.eventType = this._getEventType();
      this._addEvent();
    }

    _getEventType() {
      return window.ontouchstart ? "touchstart" : "click";
    }

    _toggle() {
      this.globalContainer.classList.toggle("is_drawerOpen");
    }

    _addEvent() {
      this.btn.addEventListener(this.eventType, this._toggle.bind(this));
      this.cover.addEventListener(this.eventType, this._toggle.bind(this));
    }
  }

  new Drawer();

  // *************** pageTopbtn ***************
  class pageTop {
    constructor(el) {
      this.el = document.querySelector(el);
      this._init();
    }

    _init() {
      const _that = this.el;
      const clientHeight = document.body.clientHeight;
      const pageBottom = clientHeight - window.innerHeight;
      const getScrolled = function () {
        return window.pageYOffset !== undefined
          ? window.pageYOffset
          : document.documentElement.scrollTop;
      };

      window.addEventListener("scroll", function () {
        if (getScrolled() > 500) {
          _that.classList.add("is_show");
          if (getScrolled() >= pageBottom - 80) {
            _that.classList.add("is_raise");
          } else {
            _that.classList.remove("is_raise");
          }
        } else {
          _that.classList.remove("is_show");
        }
      });

      // _that.addEventListener("click", function (e) {
      //   e.preventDefault();

      //   const duration = 500;
      //   let currentY = window.pageYOffset;
      //   let step = duration / currentY > 1 ? 1 : 100;
      //   let timeStep = (duration / currentY) * step;
      //   let intervalID = setInterval(scrollUp, timeStep);

      //   function scrollUp() {
      //     currentY = window.pageYOffset;
      //     if (currentY === 0) {
      //       clearInterval(intervalID);
      //     } else {
      //       scrollBy(0, -step);
      //     }
      //   }
      // });
    }
  }

  new pageTop("#pageTop");

  // *************** headerAnimation ***************
  class headerAnimation {
    constructor(el, height) {
      this.el = document.querySelector(el);
      this._init();
    }

    _init() {
      const header = this.el;
      const height = 64;
      let offset = 0;
      let lastPosition = 0;
      let ticking = false;

      function onScroll() {
        if (lastPosition > height) {
          if (lastPosition > offset) {
            header.classList.add("is_hide");
          } else {
            header.classList.remove("is_hide");
          }
          offset = lastPosition;
        }
      }

      window.addEventListener("scroll", function (e) {
        lastPosition = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            onScroll(lastPosition);
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  new headerAnimation("#headerContainer");

  // *************** news ***************

  const headerNews = document.getElementById("headerNews");
  const news = {
    1: {
      url: "https://hoshino-wp.com/danime-unext/",
      title: "「dアニメストア」と「U-NEXT」アニメ視聴におすすめなのはどっち？",
    },
    2: {
      url: "https://hoshino-wp.com/wordpress-conoha-wing/",
      title: "【簡単】WordPressの始め方｜ConoHa WING-かんたんセットアップ",
    },
    3: {
      url: "https://hoshino-wp.com/cda-mp3-windows/",
      title: "CDAファイルをMP3形式に変換する方法【Windows編】",
    },
    4: {
      url: "https://hoshino-wp.com/freenance/",
      title: "無料で利用できるフリーランスの損害賠償保険サービス【FREENANCE】",
    },
  };
  let num = Math.floor(Math.random() * 4) + 1;
  let newsUrl = news[num]["url"];
  let newsTitle = news[num]["title"];

  headerNews.href = newsUrl;
  headerNews.textContent = "Pick Up!： " + newsTitle;

  // *************** IE objectfit対応 ***************
  objectFitImages();
});

jQuery(function () {
  // *************** wrapper ***************
  var iframeWrap = jQuery('<div class="bl_iframeWrap"></div>');
  jQuery("iframe").wrap(iframeWrap);

  var twitterWrap = jQuery('<div class="bl_twitterWrap"></div>');
  jQuery(".twitter-tweet").wrap(twitterWrap);

  // *************** escape ***************
  // jQuery("code").each(function () {
  //   var text = jQuery(this).html().replace(/</g, "&lt;");
  //   var text = text.replace(/>/g, "&gt;");
  //   jQuery(this).html(text);
  // });

  // *************** アンカースクロール ***************
  jQuery('a[href^="#"]').click(function () {
    var adjust = 78;
    var speed = 1000;
    var href = jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - adjust;
    jQuery("body,html").animate({ scrollTop: position }, speed, "swing");

    setTimeout(function () {
      jQuery("#headerContainer").removeClass("is_hide");
    }, 1100);
    return false;
  });
});
